import { Typography } from '@navi/web-ui/lib/primitives';

interface BankDetailsComponentProps {
  label: string;
  value: string;
}

const BankDetailsComponent = (props: BankDetailsComponentProps) => {
  const { label, value } = props;
  return (
    <div className="flex flex-col">
      <div className="flex flex-row">
        <Typography variant="p5" color="var(--navi-color-gray-c1)">
          {label}
        </Typography>
      </div>
      <Typography variant="p3" color="var(--navi-color-gray-c2)">
        {value}
      </Typography>
    </div>
  );
};

export default BankDetailsComponent;
